import { render, staticRenderFns } from "./uploadVideoStyle.vue?vue&type=template&id=4c4fd8be&scoped=true"
import script from "./uploadVideoStyle.vue?vue&type=script&lang=js"
export * from "./uploadVideoStyle.vue?vue&type=script&lang=js"
import style0 from "./uploadVideoStyle.vue?vue&type=style&index=0&id=4c4fd8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4fd8be",
  null
  
)

export default component.exports